import { render, staticRenderFns } from "./DevIconContextMenu.vue?vue&type=template&id=21b85b4f"
import script from "./DevIconContextMenu.vue?vue&type=script&lang=js"
export * from "./DevIconContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports